import { render, staticRenderFns } from "./ThirdPartyRiskScenario.vue?vue&type=template&id=696640f4&scoped=true&"
import script from "./ThirdPartyRiskScenario.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyRiskScenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696640f4",
  null
  
)

export default component.exports